var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"fill-height"},[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('E-Learning'),"showCloseButton":true},on:{"closeEmit":_vm.close}}),_c('iframe',{ref:"iframeRef",staticClass:"scormplayer_iframe",attrs:{"name":"scormplayer_iframe","id":"scormplayer_iframe"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }